module.exports = __webpack_public_path__ + "static/online-marketplaces-ea76b18c5e8395f3c52afe3174792242.svg";